import navigateToNextOnboardingPageActionV1 from "@actions/navigateToNextOnboardingPageActionV1"
import onboardingLoader from "@loaders/onboardingLoader"
import { Navigate, Outlet } from "react-router-dom"

import AgePage from "@pages/onboarding/AgePage"
import AlmostTherePage from "@pages/onboarding/AlmostTherePage"
import BoldLooksPage from "@pages/onboarding/BoldLooksPage"
import CompanyPage from "@pages/onboarding/CompanyPage"
import ComplimentPage from "@pages/onboarding/ComplimentPage"
import ConfidenceBoostPage from "@pages/onboarding/ConfidenceBoostPage"
import DoingAmazingPage from "@pages/onboarding/DoingAmazingPage"
import ExperimentingLookPage from "@pages/onboarding/ExperimentingLookPage"
import FirstImpressionPage from "@pages/onboarding/FirstImpressionPage"
import FutureLookPage from "@pages/onboarding/FutureLookPage"
import GenderPage from "@pages/onboarding/GenderPage"
import HairstyleFrequencyPage from "@pages/onboarding/HairstyleFrequencyPage"
import PersonalityPage from "@pages/onboarding/PersonalityPage"
import PhotoUsagePage from "@pages/onboarding/PhotoUsagePage"
import ReadyToTransformPage from "@pages/onboarding/ReadyToTransformPage"
import SharePhotoPage from "@pages/onboarding/SharePhotoPage"
import StyleFeelingPage from "@pages/onboarding/StyleFeelingPage"
import StyleProfilePage from "@pages/onboarding/StyleProfilePage"
import SubscriptionCountPage from "@pages/onboarding/SubscriptionCountPage"
import TryFirstPage from "@pages/onboarding/TryFirstPage"
import TryFirstSubPage from "@pages/onboarding/TryFirstSubPage"
import UnleashLookPage from "@pages/onboarding/UnleashLookPage"

import ReadyCommitPage from "./ReadyCommitPage"
import StyleSnapshotPage from "./StyleSnapshotPage"

const action = navigateToNextOnboardingPageActionV1

const onboardingRoutesV1 = [
  {
    path: "/onboarding/v1",
    element: <Outlet />,
    loader: onboardingLoader,
    children: [
      {
        element: <Navigate to={`gender${window.location.search}`} replace />,
        index: true,
      },
      { action, element: <GenderPage />, path: "gender" },
      { action, element: <AgePage />, path: "age" },
      { action, element: <CompanyPage />, path: "company" },
      { action, element: <TryFirstPage />, path: "tryFirst" },
      { action, element: <UnleashLookPage />, path: "unleashLook" },
      { action, element: <FirstImpressionPage />, path: "firstImpression" },
      { action, element: <TryFirstSubPage />, path: "tryFirstSub" },
      { action, element: <StyleFeelingPage />, path: "styleFeeling" },
      {
        action,
        element: <HairstyleFrequencyPage />,
        path: "hairstyleFrequency",
      },
      { action, element: <BoldLooksPage />, path: "boldLooks" },
      { action, element: <SharePhotoPage />, path: "sharePhoto" },
      { action, element: <ExperimentingLookPage />, path: "experimentingLook" },
      { action, element: <DoingAmazingPage />, path: "doingAmazing" },
      { action, element: <StyleSnapshotPage />, path: "styleSnapshot" },
      { action, element: <ReadyCommitPage />, path: "readyCommit" },
      { action, element: <ConfidenceBoostPage />, path: "confidenceBoost" },
      { action, element: <FutureLookPage />, path: "futureLook" },
      { action, element: <PersonalityPage />, path: "personality" },
      { action, element: <ComplimentPage />, path: "compliment" },
      { action, element: <StyleProfilePage />, path: "styleProfile" },
      { action, element: <ReadyToTransformPage />, path: "readyToTransform" },
      { action, element: <PhotoUsagePage />, path: "photoUsage" },
      {
        action,
        element: <SubscriptionCountPage />,
        path: "subscriptionCount",
      },
      { action, element: <AlmostTherePage />, path: "almostThere" },
    ],
  },
]

export default onboardingRoutesV1
